import Vue from 'vue'
import { Avatar } from 'vue-avatar'

Vue.component('Avatar', Avatar)
